import { useCallback } from 'react'

interface Args {
  integrationAssignment: any
  onChange: any
  onLoad?: any
}

export const useIntegrationAssignment = ({ integrationAssignment, onChange, onLoad }: Args) => {
  const onIntegrationInit = useCallback(
    (defaultFields, mappingsToReset) => {
      onChange(currentOutbound => ({
        ...currentOutbound,
        [integrationAssignment.id]: {
          ...currentOutbound[integrationAssignment.id],
          mapping_fields: defaultFields,
          mappingsToReset,
        },
      }))
    },
    [integrationAssignment, onChange],
  )

  const onIntegrationResetByDataTypeChange = useCallback(
    (value, name, filtersToReset) => {
      onChange(currentOutbound => {
        let metadata = { ...currentOutbound[integrationAssignment.id].metadata }
        const mapping_fields =
          currentOutbound[integrationAssignment.id].mappingsToReset?.[value] || []

        // some integrations still take metadata filters
        filtersToReset.forEach(filter => {
          const { [filter]: _, ...rest } = metadata

          metadata = rest
        })

        return {
          ...JSON.parse(JSON.stringify(currentOutbound)),
          [integrationAssignment.id]: {
            ...currentOutbound[integrationAssignment.id],
            metadata: {
              ...metadata,
              [name]: value,
            },
            mapping_fields: mapping_fields.map(field => ({ ...field, cvFieldId: '' })),
            filters: [],
          },
        }
      })
    },
    [integrationAssignment, onChange],
  )

  const onIntegrationResetByAccountChange = useCallback(
    (value, name, dataType) => {
      onChange(currentOutbound => {
        const mapping_fields =
          currentOutbound[integrationAssignment.id].mappingsToReset?.[dataType ?? 'default'] || []

        return {
          ...currentOutbound,
          [integrationAssignment.id]: {
            ...currentOutbound[integrationAssignment.id],
            [name]: value,
            metadata: {},
            mapping_fields: mapping_fields.map(field => ({ ...field, cvFieldId: '' })),
          },
        }
      })
    },
    [integrationAssignment, onChange],
  )

  const onIntegrationLoad = useCallback(
    (value, name) => {
      onLoad(currentOutbound => ({
        ...currentOutbound,
        [integrationAssignment.id]: {
          ...currentOutbound[integrationAssignment.id],
          [name]: value,
        },
      }))
    },
    [integrationAssignment, onLoad],
  )

  const onIntegrationChange = useCallback(
    (value, name) => {
      onChange(currentOutbound => ({
        ...currentOutbound,
        [integrationAssignment.id]: {
          ...currentOutbound[integrationAssignment.id],
          [name]: value,
        },
      }))
    },
    [integrationAssignment, onChange],
  )

  const onIntegrationMetadataChange = useCallback(
    (value, name) => {
      onChange(currentOutbound => ({
        ...currentOutbound,
        [integrationAssignment.id]: {
          ...currentOutbound[integrationAssignment.id],
          metadata: {
            ...currentOutbound[integrationAssignment.id].metadata,
            [name]: value,
          },
        },
      }))
    },
    [integrationAssignment, onChange],
  )

  return {
    onIntegrationInit,
    onIntegrationLoad,
    onIntegrationChange,
    onIntegrationMetadataChange,
    onIntegrationResetByAccountChange,
    onIntegrationResetByDataTypeChange,
  }
}
